import { QuoteStateCode, QuoteType } from '@/lib/types'
import { z } from 'zod'

export type BillingContactRuleQuote = {
  dsy_type: number
  statecode: number
  dsy_salesorder?: { dsy_type?: number | null } | null
  dsy_billingcontact?: { contactid: string } | null
}

// Service work is invoiced to the billing contact — it drives the proposal
// share recipient, the paylink identity, and the sales-order handoff on win.
// Scope mirrors useIsServiceQuoteOrChangeOrder: a service invoice, or a change
// order amending a service-invoice sales order.
export function isBillingContactRequired(quote: Pick<BillingContactRuleQuote, 'dsy_type' | 'dsy_salesorder'>): boolean {
  if (quote.dsy_type === QuoteType.ServiceInvoice) return true
  return quote.dsy_type === QuoteType.ChangeOrder && quote.dsy_salesorder?.dsy_type === QuoteType.ServiceInvoice
}

/** superRefine callback for the builder-only quote schema — see getQuote(). */
export function requireServiceBillingContact(quote: BillingContactRuleQuote, ctx: z.RefinementCtx): void {
  // Won/Closed quotes are read-only in Dataverse — the fix dialog's PATCH would
  // be rejected ("Cannot Update a Read-Only Entity"), and the sales order
  // already exists, so there is nothing left to enforce. Gate Draft/Active only.
  if (quote.statecode !== QuoteStateCode.Draft && quote.statecode !== QuoteStateCode.Active) return
  if (!isBillingContactRequired(quote)) return
  if (quote.dsy_billingcontact?.contactid) return
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    path: ['dsy_billingcontact'],
    message: `Billing contact is required for service quotes. Please set the 'Billing Contact' field on the Dynamics 'Quote' record.`,
  })
}
